import React from 'react';
import moment from 'moment';
import { i18n } from '../../common/services/globalize';
import utils from './utils';
const formatDate = (data) => {
	return customDateFormat(data, 'LL');
};

const formatShortDate = (data) => {
	return customDateFormat(data, 'L');
};

const formatDateTime = (data) => {
	return customDateFormat(data, 'LLL');
};

const customDateFormat = (data, format) => {
	if (data) {
		// parse ISO string
		const momentDate = moment(data);
		if (momentDate.isValid()) {
			return momentDate.format(format);
		}
		else {
			return data;
		}
	}

	return '';
};

const formatTime = (date) => {
	if (date) {
		const momentDate = moment(date);
		if (momentDate.isValid()) {
			return momentDate.format('HH:mm');
		}
		else {
			// check if passed value is TimeSpan without date
			const dateWithTime = moment(moment().format('YYYY-MM-DDT') + date);
			if (dateWithTime.isValid()) {
				return dateWithTime.format('HH:mm');
			} else {
				return date;
			}
		}
	}
	return '';
};

const formatBoolean = (value) => value ? i18n.t('Common_Yes') : i18n.t('Common_No');
const formatAmount = (value) => value ? value.toFixed(2) : '0.00';

const formatHtmlToPlainText = (text) => {
	if (text) {
		const plainText = text.replace(/<[^>]*>/g, '');
		if (plainText && plainText.length > 125) {
			return plainText.substring(0, 120) + '...';
		}

		return plainText;
	}

	return '';
};

const makeOptionValues = (entity) => {
	if (!entity)
		return;

	let options;
	const entityArray = Object.values(entity).filter(item => !!item);
	if (entityArray.length > 0) {
		options = entityArray.map(item => <option key={item.id} value={item.id}>{item.displayName ? item.displayName : item.name}</option>);
	}
	return options;
};

const days = {
	'0': 'WeekDayType_Sunday',
	'1': 'WeekDayType_Monday',
	'2': 'WeekDayType_Tuesday',
	'3': 'WeekDayType_Wednesday',
	'4': 'WeekDayType_Thursday',
	'5': 'WeekDayType_Friday',
	'6': 'WeekDayType_Saturday',
	'7': 'WeekDayType_Sunday'
};

const weekdaysMultiSelectOptionValues = (t) => {
	const result = [];
	for (const key in days) {
		result.push({ value: key, label: t(days[key]) });
	}
	return result;
};

const paymentNotesOptions = (t) => {
	return [
		{
			label: t('LessonAttendance_BankTransferEvidence'),
			value: t('LessonAttendance_BankTransferEvidence')
		},
		{
			label: t('LessonAttendance_CashInHand'),
			value: t('LessonAttendance_CashInHand')
		},
		{
			label: t('LessonAttendance_DepositTaken'),
			value: t('LessonAttendance_DepositTaken')
		}
	];
};

const formatAge = (dateOfBirth) => {
	const age = utils.getAgeFromBirthday(dateOfBirth);
	return age && i18n.t('Child_Age', { years: age.years, months: age.months })
};

const adjustDate = (hours, minutes, seconds) => {
	const date = new Date();
	date.setHours(hours || 0);
	date.setMinutes(minutes || 0);
	date.setSeconds(seconds || 0);
	return date;
}

const daysOfMonth = () => {
	var days = Array.from({ length: 28 }, (value, index) => index + 1);
	var array = days.map(day => ({ id: day, displayName: moment().date(day).format('Do') }));
	array.push({ id: -1, displayName: i18n.t('DayOfMonth_LastDay') })
	return array;
}

const isMobileView = () => {
	return window.innerWidth <= 768;
};

export default {
	formatDate,
	formatShortDate,
	formatDateTime,
	formatBoolean,
	makeOptionValues,
	formatTime,
	days,
	customDateFormat,
	formatHtmlToPlainText,
	weekdaysMultiSelectOptionValues,
	formatAmount,
	paymentNotesOptions,
	formatAge,
	adjustDate,
	daysOfMonth,
	isMobileView
};